export const increment = state => {
  state.count++
}




// WEBPACK FOOTER //
// ./src/store/mutations.js